<template>
    <div id="sixth-mobile" :style="bg">
        <h2 :class="theme==0?'text-theme-1':theme==1?'text-theme-2':theme==2?'text-theme-3':'text-theme-4'">Contact Me</h2>
         <h3 :class="theme==1?'h3-theme-2':'h3-theme-1'">Get in touch</h3>
         <div id="contact">
            <div class="contact-info">
                <div class="contact-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="35" viewBox="0 0 27 35" fill="none" v-if="theme==0">
                        <path d="M10.1207 2.7068L10.1208 2.69728C10.1236 2.40013 10.0373 2.16307 9.86674 1.96029C9.68988 1.74999 9.49053 1.64172 9.25455 1.60886L2.9043 0.724499C2.57213 0.67824 2.29773 0.756954 2.04537 0.967363C1.79 1.18027 1.62677 1.47193 1.56974 1.88122L10.1207 2.7068ZM10.1207 2.7068L10.121 2.71632M10.1207 2.7068L10.121 2.71632M10.121 2.71632L10.2985 8.88977C10.2944 9.2521 10.2428 9.55986 10.1526 9.81942C10.0713 10.0532 9.93418 10.2517 9.7316 10.4206L9.73159 10.4206M10.121 2.71632L9.73159 10.4206M9.73159 10.4206L9.72769 10.4239M9.73159 10.4206L9.72769 10.4239M9.72769 10.4239L5.37564 14.1288L5.11111 14.354M9.72769 10.4239L5.11111 14.354M5.11111 14.354L5.22988 14.6804M5.11111 14.354L5.22988 14.6804M5.22988 14.6804C6.05389 16.9455 7.17498 19.1156 8.59143 21.1902C10.0079 23.2648 11.6328 25.1167 13.466 26.7445L13.7877 27.0302M5.22988 14.6804L13.7877 27.0302M13.7877 27.0302L14.1182 26.7546M13.7877 27.0302L14.1182 26.7546M14.1182 26.7546L18.3678 23.2115C18.565 23.0471 18.8181 22.9277 19.1445 22.8653C19.4639 22.8042 19.7542 22.8172 20.0234 22.8954L25.2451 24.8497C25.4889 24.9449 25.6735 25.1032 25.8103 25.3409C25.9451 25.5752 25.9955 25.8308 25.9541 26.128L24.9806 33.1186C24.9236 33.528 24.7603 33.8197 24.5049 34.0326C24.2526 34.243 23.9782 34.3218 23.646 34.2755C20.3594 33.8178 17.2633 32.5652 14.3536 30.5075M14.1182 26.7546L14.3536 30.5075M14.3536 30.5075C11.4328 28.4421 8.94368 25.9039 6.88503 22.89M14.3536 30.5075L6.88503 22.89M6.88503 22.89C4.82638 19.8762 3.29785 16.5298 2.30058 12.8476M6.88503 22.89L2.30058 12.8476M2.30058 12.8476C1.30635 9.17658 1.06371 5.5225 1.56973 1.88136L2.30058 12.8476Z" stroke="#A3B18A"/>
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="27" height="35" viewBox="0 0 27 35" fill="none" v-if="theme==1">
                        <path d="M10.1207 2.7068L10.1208 2.69728C10.1236 2.40013 10.0373 2.16307 9.86674 1.96029C9.68988 1.74999 9.49053 1.64172 9.25455 1.60886L2.9043 0.724499C2.57213 0.67824 2.29773 0.756954 2.04537 0.967363C1.79 1.18027 1.62677 1.47193 1.56974 1.88122L10.1207 2.7068ZM10.1207 2.7068L10.121 2.71632M10.1207 2.7068L10.121 2.71632M10.121 2.71632L10.2985 8.88977C10.2944 9.25209 10.2428 9.55986 10.1526 9.81942C10.0713 10.0532 9.93418 10.2517 9.73161 10.4206L9.73159 10.4206M10.121 2.71632L9.73159 10.4206M9.73159 10.4206L9.72768 10.4239M9.73159 10.4206L9.72768 10.4239M9.72768 10.4239L5.37564 14.1288L5.11111 14.354M9.72768 10.4239L5.11111 14.354M5.11111 14.354L5.22988 14.6804M5.11111 14.354L5.22988 14.6804M5.22988 14.6804C6.05389 16.9455 7.17498 19.1156 8.59143 21.1902C10.0079 23.2648 11.6328 25.1167 13.466 26.7445L13.7877 27.0302M5.22988 14.6804L13.7877 27.0302M13.7877 27.0302L14.1182 26.7546M13.7877 27.0302L14.1182 26.7546M14.1182 26.7546L18.3678 23.2115C18.565 23.0471 18.8181 22.9277 19.1445 22.8653C19.4639 22.8042 19.7542 22.8172 20.0234 22.8954L25.2451 24.8497C25.4889 24.9449 25.6735 25.1032 25.8103 25.3409C25.9451 25.5752 25.9955 25.8308 25.9541 26.128L24.9806 33.1186C24.9236 33.528 24.7603 33.8197 24.5049 34.0326C24.2526 34.243 23.9782 34.3218 23.646 34.2755C20.3594 33.8178 17.2633 32.5652 14.3536 30.5075M14.1182 26.7546L14.3536 30.5075M14.3536 30.5075C11.4328 28.4421 8.94368 25.9039 6.88503 22.89M14.3536 30.5075L6.88503 22.89M6.88503 22.89C4.82638 19.8762 3.29784 16.5298 2.30058 12.8476M6.88503 22.89L2.30058 12.8476M2.30058 12.8476C1.30635 9.17658 1.06371 5.5225 1.56973 1.88136L2.30058 12.8476Z" stroke="#3A5A40"/>
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="27" height="35" viewBox="0 0 27 35" fill="none" v-if="theme==2 || theme==3">
                        <path d="M10.1207 2.7068L10.1208 2.69728C10.1236 2.40013 10.0373 2.16307 9.86674 1.96029C9.68988 1.74999 9.49053 1.64172 9.25455 1.60886L2.9043 0.724499C2.57213 0.67824 2.29773 0.756954 2.04537 0.967363C1.79 1.18027 1.62677 1.47193 1.56974 1.88122L10.1207 2.7068ZM10.1207 2.7068L10.121 2.71632M10.1207 2.7068L10.121 2.71632M10.121 2.71632L10.2985 8.88975C10.2944 9.25208 10.2428 9.55985 10.1526 9.81942C10.0713 10.0532 9.93418 10.2517 9.7316 10.4206L9.73159 10.4206M10.121 2.71632L9.73159 10.4206M9.73159 10.4206L9.72769 10.4239M9.73159 10.4206L9.72769 10.4239M9.72769 10.4239L5.37564 14.1288L5.11111 14.354M9.72769 10.4239L5.11111 14.354M5.11111 14.354L5.22988 14.6804M5.11111 14.354L5.22988 14.6804M5.22988 14.6804C6.05389 16.9455 7.17498 19.1156 8.59144 21.1902C10.0079 23.2648 11.6328 25.1167 13.466 26.7445L13.7877 27.0302M5.22988 14.6804L13.7877 27.0302M13.7877 27.0302L14.1182 26.7546M13.7877 27.0302L14.1182 26.7546M14.1182 26.7546L18.3678 23.2115C18.565 23.0471 18.8181 22.9277 19.1445 22.8653C19.4639 22.8042 19.7542 22.8172 20.0234 22.8954L25.2451 24.8497C25.4889 24.9449 25.6735 25.1032 25.8103 25.3409C25.9451 25.5752 25.9955 25.8308 25.9541 26.128L24.9806 33.1186C24.9236 33.528 24.7603 33.8197 24.5049 34.0326C24.2526 34.243 23.9782 34.3218 23.646 34.2755C20.3594 33.8178 17.2633 32.5652 14.3536 30.5075M14.1182 26.7546L14.3536 30.5075M14.3536 30.5075C11.4328 28.4421 8.94368 25.9039 6.88503 22.89M14.3536 30.5075L6.88503 22.89M6.88503 22.89C4.82638 19.8762 3.29785 16.5298 2.30058 12.8476M6.88503 22.89L2.30058 12.8476M2.30058 12.8476C1.30635 9.17658 1.06371 5.5225 1.56973 1.88136L2.30058 12.8476Z" stroke="#D4ADFC"/>
                      </svg>
                </div>
                <div class="contact-detail">
                    <h2 :class="theme==1?'contact-h2-2':'contact-h2-1'">Call Me</h2>
                    <h3 :class="theme==1?'contact-h3-2':'contact-h3-1'">+917895724996</h3>
                </div>
            </div>
            <div class="contact-info">
                <div class="contact-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="23" viewBox="0 0 29 23" fill="none" v-if="theme==0">
                        <path d="M29 2.875C29 1.29375 27.695 0 26.1 0H2.9C1.305 0 0 1.29375 0 2.875V20.125C0 21.7062 1.305 23 2.9 23H26.1C27.695 23 29 21.7062 29 20.125V2.875ZM26.1 2.875L14.5 10.0481L2.9 2.875H26.1ZM26.1 20.125H2.9V5.75L14.5 12.9375L26.1 5.75V20.125Z" fill="#A3B18A"/>
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="29" height="23" viewBox="0 0 29 23" fill="none" v-if="theme==1">
                        <path d="M29 2.875C29 1.29375 27.695 0 26.1 0H2.9C1.305 0 0 1.29375 0 2.875V20.125C0 21.7062 1.305 23 2.9 23H26.1C27.695 23 29 21.7062 29 20.125V2.875ZM26.1 2.875L14.5 10.0481L2.9 2.875H26.1ZM26.1 20.125H2.9V5.75L14.5 12.9375L26.1 5.75V20.125Z" fill="#3A5A40"/>
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="29" height="23" viewBox="0 0 29 23" fill="none" v-if="theme==2 || theme==3">
                        <path d="M29 2.875C29 1.29375 27.695 0 26.1 0H2.9C1.305 0 0 1.29375 0 2.875V20.125C0 21.7063 1.305 23 2.9 23H26.1C27.695 23 29 21.7063 29 20.125V2.875ZM26.1 2.875L14.5 10.0481L2.9 2.875H26.1ZM26.1 20.125H2.9V5.75L14.5 12.9375L26.1 5.75V20.125Z" fill="#D4ADFC"/>
                      </svg>
                </div>
                <div class="contact-detail">
                    <h2 :class="theme==1?'contact-h2-2':'contact-h2-1'">Email</h2>
                    <h3 :class="theme==1?'contact-h3-2':'contact-h3-1'">dumkaabhipray@gmail.com</h3>
                </div>
            </div>
            <div class="contact-info">
                <div class="contact-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="30" viewBox="0 0 23 30" fill="none" v-if="theme==0">
                        <path d="M13.7157 29.0543C17.0564 25.7636 23 19.0406 23 12.8711C23 9.45744 21.7884 6.18363 19.6317 3.76984C17.4751 1.35605 14.55 0 11.5 0C8.45001 0 5.52494 1.35605 3.36827 3.76984C1.2116 6.18363 4.54484e-08 9.45744 0 12.8711C0 19.0406 5.94167 25.7636 9.28433 29.0543C9.89405 29.6634 10.6827 30 11.5 30C12.3173 30 13.106 29.6634 13.7157 29.0543ZM7.66667 12.8711C7.66667 11.7332 8.07053 10.6419 8.78942 9.83732C9.50831 9.03272 10.4833 8.5807 11.5 8.5807C12.5167 8.5807 13.4917 9.03272 14.2106 9.83732C14.9295 10.6419 15.3333 11.7332 15.3333 12.8711C15.3333 14.0089 14.9295 15.1002 14.2106 15.9048C13.4917 16.7094 12.5167 17.1614 11.5 17.1614C10.4833 17.1614 9.50831 16.7094 8.78942 15.9048C8.07053 15.1002 7.66667 14.0089 7.66667 12.8711Z" fill="#A3B18A"/>
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="30" viewBox="0 0 23 30" fill="none" v-if="theme==1">
                        <path d="M13.7157 29.0543C17.0564 25.7636 23 19.0406 23 12.8711C23 9.45744 21.7884 6.18363 19.6317 3.76984C17.4751 1.35605 14.55 0 11.5 0C8.45001 0 5.52494 1.35605 3.36827 3.76984C1.2116 6.18363 4.54484e-08 9.45744 0 12.8711C0 19.0406 5.94167 25.7636 9.28433 29.0543C9.89405 29.6634 10.6827 30 11.5 30C12.3173 30 13.106 29.6634 13.7157 29.0543ZM7.66667 12.8711C7.66667 11.7332 8.07053 10.6419 8.78942 9.83732C9.50831 9.03272 10.4833 8.5807 11.5 8.5807C12.5167 8.5807 13.4917 9.03272 14.2106 9.83732C14.9295 10.6419 15.3333 11.7332 15.3333 12.8711C15.3333 14.0089 14.9295 15.1002 14.2106 15.9048C13.4917 16.7094 12.5167 17.1614 11.5 17.1614C10.4833 17.1614 9.50831 16.7094 8.78942 15.9048C8.07053 15.1002 7.66667 14.0089 7.66667 12.8711Z" fill="#3A5A40"/>
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="30" viewBox="0 0 23 30" fill="none" v-if="theme==2 || theme==3">
                        <path d="M13.7157 29.0543C17.0564 25.7636 23 19.0406 23 12.8711C23 9.45744 21.7884 6.18363 19.6317 3.76984C17.4751 1.35605 14.55 0 11.5 0C8.45001 0 5.52494 1.35605 3.36827 3.76984C1.2116 6.18363 4.54484e-08 9.45744 0 12.8711C0 19.0406 5.94167 25.7636 9.28433 29.0543C9.89405 29.6634 10.6827 30 11.5 30C12.3173 30 13.106 29.6634 13.7157 29.0543ZM7.66667 12.8711C7.66667 11.7332 8.07053 10.6419 8.78942 9.83732C9.50831 9.03272 10.4833 8.5807 11.5 8.5807C12.5167 8.5807 13.4917 9.03272 14.2106 9.83732C14.9295 10.6419 15.3333 11.7332 15.3333 12.8711C15.3333 14.0089 14.9295 15.1002 14.2106 15.9048C13.4917 16.7094 12.5167 17.1614 11.5 17.1614C10.4833 17.1614 9.50831 16.7094 8.78942 15.9048C8.07053 15.1002 7.66667 14.0089 7.66667 12.8711Z" fill="#D4ADFC"/>
                      </svg>
                </div>
                <div class="contact-detail">
                    <h2 :class="theme==1?'contact-h2-2':'contact-h2-1'">Location</h2>
                    <h3 :class="theme==1?'contact-h3-2':'contact-h3-1'">Haldwani,Uttrakhand,India</h3>
                </div>
            </div>
         </div>
         <div id="form">
           <input type="text" placeholder="Name" :class="theme==0?'contact-input-1':theme==1?'contact-input-2':'contact-input-3'" v-model="name">
           <input type="text" placeholder="Email" :class="theme==0?'contact-input-1':theme==1?'contact-input-2':'contact-input-3'" v-model="email">
           <input type="text" placeholder="Contact" :class="theme==0?'contact-input-1':theme==1?'contact-input-2':'contact-input-3'" v-model="project">
           <textarea id="text-area" cols="24" rows="5" :class="theme==0?'contact-text-area-1':theme==1?'contact-text-area-2':'contact-text-area-3'" v-model="Message" placeholder="message" style="resize: none;"></textarea>
         </div>
         <div :class="theme==0?'pg-2-btn-1':theme==1?'pg-2-btn-2':theme==3?'pg-2-btn-3':'pg-2-btn-4'" @click="send">
            <h3>Send Message</h3>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" v-if="theme==0">
                <g filter="url(#filter0_d_2_595)">
                  <path d="M4.17711 0.118741C4.2518 0.0553713 4.34345 0.015334 4.4407 0.00360069C4.53794 -0.00813263 4.63649 0.00895482 4.72411 0.0527415L17.7241 6.55274C17.807 6.59431 17.8768 6.65814 17.9255 6.73708C17.9743 6.81602 18.0001 6.90697 18.0001 6.99974C18.0001 7.09252 17.9743 7.18346 17.9255 7.2624C17.8768 7.34135 17.807 7.40517 17.7241 7.44674L4.72411 13.9467C4.63655 13.9906 4.53803 14.0079 4.44077 13.9963C4.34351 13.9847 4.2518 13.9447 4.17703 13.8815C4.10226 13.8182 4.04771 13.7344 4.02017 13.6404C3.99263 13.5464 3.9933 13.4464 4.02211 13.3527L5.97711 6.99974L4.02211 0.646742C3.99347 0.553219 3.99289 0.45335 4.02044 0.3595C4.04799 0.265651 4.10246 0.181943 4.17711 0.118741ZM6.86911 7.49974L5.32211 12.5297L16.3821 6.99974L5.32211 1.46974L6.86911 6.49974H12.5001C12.6327 6.49974 12.7599 6.55242 12.8537 6.64619C12.9474 6.73996 13.0001 6.86713 13.0001 6.99974C13.0001 7.13235 12.9474 7.25953 12.8537 7.3533C12.7599 7.44706 12.6327 7.49974 12.5001 7.49974H6.86911Z" fill="#344E41"/>
                </g>
                <defs>
                  <filter id="filter0_d_2_595" x="0" y="0" width="22.0001" height="21.9998" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_595"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_595" result="shape"/>
                  </filter>
                </defs>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" v-if="theme==1">
                <g filter="url(#filter0_d_2_1841)">
                  <path d="M4.17711 0.118741C4.2518 0.0553713 4.34345 0.015334 4.4407 0.00360069C4.53794 -0.00813263 4.63649 0.00895482 4.72411 0.0527415L17.7241 6.55274C17.807 6.59431 17.8768 6.65814 17.9255 6.73708C17.9743 6.81602 18.0001 6.90697 18.0001 6.99974C18.0001 7.09252 17.9743 7.18346 17.9255 7.2624C17.8768 7.34135 17.807 7.40517 17.7241 7.44674L4.72411 13.9467C4.63655 13.9906 4.53803 14.0079 4.44077 13.9963C4.34351 13.9847 4.2518 13.9447 4.17703 13.8815C4.10226 13.8182 4.04771 13.7344 4.02017 13.6404C3.99263 13.5464 3.9933 13.4464 4.02211 13.3527L5.97711 6.99974L4.02211 0.646742C3.99347 0.553219 3.99289 0.45335 4.02044 0.3595C4.04799 0.265651 4.10246 0.181943 4.17711 0.118741ZM6.86911 7.49974L5.32211 12.5297L16.3821 6.99974L5.32211 1.46974L6.86911 6.49974H12.5001C12.6327 6.49974 12.7599 6.55242 12.8537 6.64619C12.9474 6.73996 13.0001 6.86713 13.0001 6.99974C13.0001 7.13235 12.9474 7.25953 12.8537 7.3533C12.7599 7.44706 12.6327 7.49974 12.5001 7.49974H6.86911Z" fill="#A3B18A"/>
                </g>
                <defs>
                  <filter id="filter0_d_2_1841" x="0" y="0" width="22.0001" height="21.9998" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_1841"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_1841" result="shape"/>
                  </filter>
                </defs>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" v-if="theme==2 || theme==3 ">
                <g filter="url(#filter0_d_207_743)">
                  <path d="M4.17711 0.118741C4.2518 0.0553713 4.34345 0.015334 4.4407 0.00360069C4.53794 -0.00813263 4.63649 0.00895482 4.72411 0.0527415L17.7241 6.55274C17.807 6.59431 17.8768 6.65814 17.9255 6.73708C17.9743 6.81602 18.0001 6.90697 18.0001 6.99974C18.0001 7.09252 17.9743 7.18346 17.9255 7.2624C17.8768 7.34135 17.807 7.40517 17.7241 7.44674L4.72411 13.9467C4.63655 13.9906 4.53803 14.0079 4.44077 13.9963C4.34351 13.9847 4.2518 13.9447 4.17703 13.8815C4.10226 13.8182 4.04771 13.7344 4.02017 13.6404C3.99263 13.5464 3.9933 13.4464 4.02211 13.3527L5.97711 6.99974L4.02211 0.646742C3.99347 0.553219 3.99289 0.45335 4.02044 0.3595C4.04799 0.265651 4.10246 0.181943 4.17711 0.118741ZM6.86911 7.49974L5.32211 12.5297L16.3821 6.99974L5.32211 1.46974L6.86911 6.49974H12.5001C12.6327 6.49974 12.7599 6.55242 12.8537 6.64619C12.9474 6.73996 13.0001 6.86713 13.0001 6.99974C13.0001 7.13235 12.9474 7.25953 12.8537 7.3533C12.7599 7.44706 12.6327 7.49974 12.5001 7.49974H6.86911Z" fill="#0C134F"/>
                </g>
                <defs>
                  <filter id="filter0_d_207_743" x="0" y="0" width="22" height="22" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_207_743"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_207_743" result="shape"/>
                  </filter>
                </defs>
              </svg>
        </div>
        <h2 :class="theme==0?'signature-1':theme==1?'signature-2':'signature-3'">
            Abhipray Dumka
        </h2>
        <h3 :class="theme==1?'sig-2':'sig-1'">Software Developer</h3>
        <div class="links">
            <h3 :class="theme==1?'a-2':'a-1'" @click="$emit('go-to','fourth-page')">Services</h3>
        <h3 :class="theme==1?'a-2':'a-1'" @click="$emit('go-to','fifth-page')">Portfolio</h3>
        <h3 :class="theme==1?'a-2':'a-1'" @click="$emit('go-to','sixth-page')">Contact Me</h3>
        </div>
        <div class="links1" style="padding-bottom:5px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="34" height="35" viewBox="0 0 34 35" fill="none" v-if="theme==1" @click="goto('https://www.instagram.com/abhipra_dumka/')">
                <g filter="url(#filter0_d_2_1930)">
                  <path d="M17 9.45C15.9657 9.45 14.9737 9.87669 14.2423 10.6362C13.5109 11.3957 13.1 12.4259 13.1 13.5C13.1 14.5741 13.5109 15.6043 14.2423 16.3638C14.9737 17.1233 15.9657 17.55 17 17.55C18.0343 17.55 19.0263 17.1233 19.7577 16.3638C20.4891 15.6043 20.9 14.5741 20.9 13.5C20.9 12.4259 20.4891 11.3957 19.7577 10.6362C19.0263 9.87669 18.0343 9.45 17 9.45ZM17 6.75C18.7239 6.75 20.3772 7.46116 21.5962 8.72703C22.8152 9.9929 23.5 11.7098 23.5 13.5C23.5 15.2902 22.8152 17.0071 21.5962 18.273C20.3772 19.5388 18.7239 20.25 17 20.25C15.2761 20.25 13.6228 19.5388 12.4038 18.273C11.1848 17.0071 10.5 15.2902 10.5 13.5C10.5 11.7098 11.1848 9.9929 12.4038 8.72703C13.6228 7.46116 15.2761 6.75 17 6.75ZM25.45 6.4125C25.45 6.86005 25.2788 7.28928 24.974 7.60574C24.6693 7.92221 24.256 8.1 23.825 8.1C23.394 8.1 22.9807 7.92221 22.676 7.60574C22.3712 7.28928 22.2 6.86005 22.2 6.4125C22.2 5.96495 22.3712 5.53573 22.676 5.21926C22.9807 4.90279 23.394 4.725 23.825 4.725C24.256 4.725 24.6693 4.90279 24.974 5.21926C25.2788 5.53573 25.45 5.96495 25.45 6.4125ZM17 2.7C13.7838 2.7 13.2586 2.70945 11.7623 2.7783C10.7431 2.82825 10.0593 2.97 9.4249 3.2265C8.894 3.42892 8.41404 3.75335 8.0209 4.17555C7.61401 4.58379 7.30116 5.08219 7.1057 5.63355C6.8587 6.29505 6.7222 7.0038 6.6754 8.06085C6.6078 9.55125 6.5987 10.0724 6.5987 13.5C6.5987 16.8412 6.6078 17.3853 6.6741 18.9391C6.7222 19.9962 6.8587 20.7077 7.1044 21.3651C7.3254 21.9524 7.5854 22.3749 8.017 22.8231C8.4551 23.2767 8.862 23.548 9.421 23.7722C10.0632 24.03 10.747 24.1731 11.761 24.2217C13.1962 24.2919 13.698 24.3 16.9987 24.3C20.2162 24.3 20.7401 24.2906 22.2364 24.2217C23.253 24.1717 23.9368 24.03 24.5725 23.7749C25.1029 23.5714 25.5827 23.2471 25.9765 22.8258C26.4146 22.3722 26.6759 21.9496 26.8917 21.3678C27.1387 20.7036 27.2765 19.9935 27.3233 18.9378C27.3909 17.4487 27.3987 16.9263 27.3987 13.5C27.3987 10.1601 27.3896 9.6147 27.3233 8.06085C27.2752 7.00515 27.1374 6.29235 26.8917 5.63355C26.6957 5.08277 26.3835 4.58458 25.9778 4.17555C25.5849 3.75279 25.1049 3.42788 24.5738 3.22515C23.9368 2.96865 23.253 2.8269 22.2364 2.7783C20.8025 2.7081 20.302 2.7 17 2.7ZM17 0C20.5321 0 20.9728 0.0134999 22.3599 0.0809999C23.7431 0.1485 24.6869 0.37395 25.515 0.70875C26.373 1.05165 27.0958 1.51605 27.8186 2.2653C28.4796 2.94016 28.9911 3.75649 29.3175 4.6575C29.6386 5.51745 29.857 6.49755 29.922 7.9353C29.9831 9.3744 30 9.83205 30 13.5C30 17.1679 29.987 17.6256 29.922 19.0647C29.857 20.5025 29.6386 21.4812 29.3175 22.3425C28.992 23.244 28.4804 24.0605 27.8186 24.7347C27.1686 25.4209 26.3825 25.9521 25.515 26.2913C24.6869 26.6247 23.7431 26.8515 22.3599 26.919C20.9728 26.9825 20.5321 27 17 27C13.4679 27 13.0272 26.9865 11.6401 26.919C10.2569 26.8515 9.3144 26.6247 8.485 26.2913C7.61702 25.953 6.83079 25.4218 6.1814 24.7347C5.52026 24.0599 5.00875 23.2436 4.6825 22.3425C4.3601 21.4825 4.143 20.5025 4.078 19.0647C4.0156 17.6256 4 17.1679 4 13.5C4 9.83205 4.013 9.3744 4.078 7.9353C4.143 6.4962 4.3601 5.5188 4.6825 4.6575C5.00781 3.75594 5.51944 2.93938 6.1814 2.2653C6.83097 1.57846 7.61716 1.04723 8.485 0.70875C9.3131 0.37395 10.2556 0.1485 11.6401 0.0809999C13.0272 0.0175499 13.4679 0 17 0Z" fill="#588157"/>
                </g>
                <defs>
                  <filter id="filter0_d_2_1930" x="0" y="0" width="34" height="35" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_1930"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_1930" result="shape"/>
                  </filter>
                </defs>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="34" height="35" viewBox="0 0 34 35" fill="none" v-else @click="goto('https://www.instagram.com/abhipra_dumka/')">
                <g filter="url(#filter0_d_2_1290)">
                  <path d="M17 9.45C15.9657 9.45 14.9737 9.87669 14.2423 10.6362C13.5109 11.3957 13.1 12.4259 13.1 13.5C13.1 14.5741 13.5109 15.6043 14.2423 16.3638C14.9737 17.1233 15.9657 17.55 17 17.55C18.0343 17.55 19.0263 17.1233 19.7577 16.3638C20.4891 15.6043 20.9 14.5741 20.9 13.5C20.9 12.4259 20.4891 11.3957 19.7577 10.6362C19.0263 9.87669 18.0343 9.45 17 9.45ZM17 6.75C18.7239 6.75 20.3772 7.46116 21.5962 8.72703C22.8152 9.9929 23.5 11.7098 23.5 13.5C23.5 15.2902 22.8152 17.0071 21.5962 18.273C20.3772 19.5388 18.7239 20.25 17 20.25C15.2761 20.25 13.6228 19.5388 12.4038 18.273C11.1848 17.0071 10.5 15.2902 10.5 13.5C10.5 11.7098 11.1848 9.9929 12.4038 8.72703C13.6228 7.46116 15.2761 6.75 17 6.75ZM25.45 6.4125C25.45 6.86005 25.2788 7.28928 24.974 7.60574C24.6693 7.92221 24.256 8.1 23.825 8.1C23.394 8.1 22.9807 7.92221 22.676 7.60574C22.3712 7.28928 22.2 6.86005 22.2 6.4125C22.2 5.96495 22.3712 5.53573 22.676 5.21926C22.9807 4.90279 23.394 4.725 23.825 4.725C24.256 4.725 24.6693 4.90279 24.974 5.21926C25.2788 5.53573 25.45 5.96495 25.45 6.4125ZM17 2.7C13.7838 2.7 13.2586 2.70945 11.7623 2.7783C10.7431 2.82825 10.0593 2.97 9.4249 3.2265C8.894 3.42892 8.41404 3.75335 8.0209 4.17555C7.61401 4.58379 7.30116 5.08219 7.1057 5.63355C6.8587 6.29505 6.7222 7.0038 6.6754 8.06085C6.6078 9.55125 6.5987 10.0724 6.5987 13.5C6.5987 16.8412 6.6078 17.3853 6.6741 18.9391C6.7222 19.9962 6.8587 20.7077 7.1044 21.3651C7.3254 21.9524 7.5854 22.3749 8.017 22.8231C8.4551 23.2767 8.862 23.548 9.421 23.7722C10.0632 24.03 10.747 24.1731 11.761 24.2217C13.1962 24.2919 13.698 24.3 16.9987 24.3C20.2162 24.3 20.7401 24.2906 22.2364 24.2217C23.253 24.1717 23.9368 24.03 24.5725 23.7749C25.1029 23.5714 25.5827 23.2471 25.9765 22.8258C26.4146 22.3722 26.6759 21.9496 26.8917 21.3678C27.1387 20.7036 27.2765 19.9935 27.3233 18.9378C27.3909 17.4487 27.3987 16.9263 27.3987 13.5C27.3987 10.1601 27.3896 9.6147 27.3233 8.06085C27.2752 7.00515 27.1374 6.29235 26.8917 5.63355C26.6957 5.08277 26.3835 4.58458 25.9778 4.17555C25.5849 3.75279 25.1049 3.42788 24.5738 3.22515C23.9368 2.96865 23.253 2.8269 22.2364 2.7783C20.8025 2.7081 20.302 2.7 17 2.7ZM17 0C20.5321 0 20.9728 0.0134999 22.3599 0.0809999C23.7431 0.1485 24.6869 0.37395 25.515 0.70875C26.373 1.05165 27.0958 1.51605 27.8186 2.2653C28.4796 2.94016 28.9911 3.75649 29.3175 4.6575C29.6386 5.51745 29.857 6.49755 29.922 7.9353C29.9831 9.3744 30 9.83205 30 13.5C30 17.1679 29.987 17.6256 29.922 19.0647C29.857 20.5025 29.6386 21.4812 29.3175 22.3425C28.992 23.244 28.4804 24.0605 27.8186 24.7347C27.1686 25.4209 26.3825 25.9521 25.515 26.2913C24.6869 26.6247 23.7431 26.8515 22.3599 26.919C20.9728 26.9825 20.5321 27 17 27C13.4679 27 13.0272 26.9865 11.6401 26.919C10.2569 26.8515 9.3144 26.6247 8.485 26.2913C7.61702 25.953 6.83079 25.4218 6.1814 24.7347C5.52026 24.0599 5.00875 23.2436 4.6825 22.3425C4.3601 21.4825 4.143 20.5025 4.078 19.0647C4.0156 17.6256 4 17.1679 4 13.5C4 9.83205 4.013 9.3744 4.078 7.9353C4.143 6.4962 4.3601 5.5188 4.6825 4.6575C5.00781 3.75594 5.51944 2.93938 6.1814 2.2653C6.83097 1.57846 7.61716 1.04723 8.485 0.70875C9.3131 0.37395 10.2556 0.1485 11.6401 0.0809999C13.0272 0.0175499 13.4679 0 17 0Z" fill="#DAD7CD"/>
                </g>
                <defs>
                  <filter id="filter0_d_2_1290" x="0" y="0" width="34" height="35" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_1290"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_1290" result="shape"/>
                  </filter>
                </defs>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="33" viewBox="0 0 36 33" fill="none" v-if="theme==1" @click="sendMail">
                <g filter="url(#filter0_d_2_1931)">
                  <path d="M29.2 21.875H26.4V8.20312L18 14.0625L9.6 8.20312V21.875H6.8V3.125H8.48L18 9.76562L27.52 3.125H29.2M29.2 0H6.8C5.246 0 4 1.39062 4 3.125V21.875C4 22.7038 4.295 23.4987 4.8201 24.0847C5.3452 24.6708 6.05739 25 6.8 25H29.2C29.9426 25 30.6548 24.6708 31.1799 24.0847C31.705 23.4987 32 22.7038 32 21.875V3.125C32 2.2962 31.705 1.50134 31.1799 0.915291C30.6548 0.32924 29.9426 0 29.2 0Z" fill="#588157"/>
                </g>
                <defs>
                  <filter id="filter0_d_2_1931" x="0" y="0" width="36" height="33" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_1931"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_1931" result="shape"/>
                  </filter>
                </defs>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="33" viewBox="0 0 36 33" fill="none" v-else  @click="sendMail">
                <g filter="url(#filter0_d_2_1291)">
                  <path d="M29.2 21.875H26.4V8.20312L18 14.0625L9.6 8.20312V21.875H6.8V3.125H8.48L18 9.76562L27.52 3.125H29.2M29.2 0H6.8C5.246 0 4 1.39062 4 3.125V21.875C4 22.7038 4.295 23.4987 4.8201 24.0847C5.3452 24.6708 6.05739 25 6.8 25H29.2C29.9426 25 30.6548 24.6708 31.1799 24.0847C31.705 23.4987 32 22.7038 32 21.875V3.125C32 2.2962 31.705 1.50134 31.1799 0.915291C30.6548 0.32924 29.9426 0 29.2 0Z" fill="#DAD7CD"/>
                </g>
                <defs>
                  <filter id="filter0_d_2_1291" x="0" y="0" width="36" height="33" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_1291"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_1291" result="shape"/>
                  </filter>
                </defs>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none" v-if="theme==1" @click="goto('https://github.com/abhipray-cpu')">
                <g filter="url(#filter0_d_2_1927)">
                  <path d="M25.7052 29V24.9874C25.7524 24.3207 25.6714 23.6505 25.4678 23.0213C25.2642 22.3921 24.9425 21.8184 24.5242 21.3383C28.4693 20.8489 32.6155 19.1851 32.6155 11.5514C32.6152 9.59935 31.9404 7.72218 30.7309 6.3084C31.3036 4.6006 31.2631 2.7129 30.6178 1.03746C30.6178 1.03746 29.1352 0.548116 25.7052 3.10669C22.8255 2.2382 19.79 2.2382 16.9104 3.10669C13.4804 0.548116 11.9978 1.03746 11.9978 1.03746C11.3525 2.7129 11.312 4.6006 11.8847 6.3084C10.6662 7.73267 9.9907 9.6268 10.0001 11.5933C10.0001 19.1712 14.1462 20.8349 18.0914 21.3802C17.678 21.8555 17.3592 22.4224 17.1557 23.0439C16.9523 23.6653 16.8686 24.3276 16.9104 24.9874V29" stroke="#588157" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M13.7949 28.2037C10.0256 29.5641 6.88462 28.2037 5 24.0093" stroke="#588157" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                  <filter id="filter0_d_2_1927" x="0.249756" y="0.25" width="37.1157" height="37.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_1927"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_1927" result="shape"/>
                  </filter>
                </defs>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none" v-else  @click="goto('https://github.com/abhipray-cpu')">
                <g filter="url(#filter0_d_2_1287)">
                  <path d="M25.7052 29V24.9874C25.7524 24.3207 25.6714 23.6505 25.4678 23.0213C25.2642 22.3921 24.9425 21.8184 24.5242 21.3383C28.4693 20.8489 32.6155 19.1851 32.6155 11.5514C32.6152 9.59935 31.9404 7.72218 30.7309 6.3084C31.3036 4.6006 31.2631 2.7129 30.6178 1.03746C30.6178 1.03746 29.1352 0.548116 25.7052 3.10669C22.8255 2.2382 19.79 2.2382 16.9104 3.10669C13.4804 0.548116 11.9978 1.03746 11.9978 1.03746C11.3525 2.7129 11.312 4.6006 11.8847 6.3084C10.6662 7.73267 9.9907 9.6268 10.0001 11.5933C10.0001 19.1712 14.1462 20.8349 18.0914 21.3802C17.678 21.8555 17.3592 22.4224 17.1557 23.0439C16.9523 23.6653 16.8686 24.3276 16.9104 24.9874V29" stroke="#DAD7CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M13.7949 28.2037C10.0256 29.5641 6.88462 28.2037 5 24.0094" stroke="#DAD7CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                  <filter id="filter0_d_2_1287" x="0.249756" y="0.25" width="37.1157" height="37.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_1287"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_1287" result="shape"/>
                  </filter>
                </defs>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none" v-if="theme==1" @click="goto('https://dumkaabhipray.wixsite.com/avi-talks')">
                <g filter="url(#filter0_d_253_10)">
                  <path d="M16.3257 12.4466C16.69 12.0746 16.7963 12.0594 19.0884 12.0594C21.1528 12.0594 21.2211 12.067 21.5247 12.2188C21.9649 12.439 22.1546 12.7502 22.1546 13.2512C22.1546 13.6991 21.9725 14.0104 21.5778 14.2685C21.3653 14.4051 21.2363 14.4127 19.2174 14.4279C17.9727 14.4355 16.9784 14.4127 16.8267 14.3671C16.0449 14.147 15.7565 13.0235 16.3257 12.4466ZM20.9858 19.6203C16.895 19.6203 16.7508 19.6354 16.4168 19.9315C16.1512 20.1668 15.9842 20.6451 16.0297 20.9867C16.0829 21.3435 16.394 21.7534 16.728 21.8976C16.895 21.9735 17.7981 22.0267 21.001 21.9887L24.6365 21.9432L25.3347 21.8293C26.0178 21.4421 26.1317 20.5084 25.57 19.977C25.1678 19.6203 25.1905 19.6203 20.9858 19.6203ZM37.9413 29.4964C37.6757 31.6523 36.1957 33.3224 34.0629 33.8613C33.5165 33.998 33.3267 34.0056 20.9403 33.998C8.96369 33.998 8.34892 33.9904 7.88594 33.8613C7.24841 33.6943 6.70195 33.4438 6.19343 33.1022C5.76841 32.8138 5.13846 32.2065 4.90318 31.8573C4.61477 31.4322 4.28082 30.6958 4.1442 30.1872C4.00759 29.6786 4 29.4736 4 17.0241C4 4.64281 4 4.37712 4.13662 3.83815C4.61477 1.96312 6.10236 0.528385 8.02256 0.103277C8.57661 -0.0181819 33.2281 -0.0409557 33.8277 0.0805035C35.4367 0.406925 36.7042 1.3786 37.4404 2.8437C38.0248 4.00515 37.9716 2.72983 37.9944 16.5534C38.0096 25.344 37.9944 29.0409 37.9413 29.4964ZM31.4597 15.4375C31.3762 15.0579 31.1409 14.7087 30.8752 14.5645C30.7918 14.519 30.2681 14.4658 29.6988 14.4355C28.7577 14.3899 28.6515 14.3747 28.3479 14.2001C27.8773 13.9269 27.7483 13.6232 27.7407 12.8109C27.7407 11.2623 27.0956 9.82001 25.8205 8.52192C24.9097 7.59579 23.9003 6.96572 22.7391 6.61653C22.4658 6.53302 21.8435 6.50266 19.7639 6.47989C16.5079 6.44193 15.7793 6.51025 14.6712 6.95054C12.6219 7.7628 11.1571 9.486 10.6182 11.6874C10.5196 12.0974 10.4968 12.7654 10.474 16.5686C10.4437 21.3359 10.474 22.0418 10.7776 22.9832C11.5138 25.3137 13.5934 27.0369 15.6806 27.4164C16.3789 27.5455 24.9553 27.5758 25.8281 27.4544C27.3536 27.2494 28.5528 26.6345 29.6761 25.4882C30.4882 24.6608 30.9967 23.7575 31.3306 22.5656C31.5735 21.7382 31.5507 15.855 31.4597 15.4375Z" fill="#3A5A40"/>
                </g>
                <defs>
                  <filter id="filter0_d_253_10" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_253_10"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_253_10" result="shape"/>
                  </filter>
                </defs>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none" v-else @click="goto('https://dumkaabhipray.wixsite.com/avi-talks')">
                <g filter="url(#filter0_d_253_9)">
                  <path d="M16.3257 12.4466C16.69 12.0746 16.7963 12.0594 19.0884 12.0594C21.1528 12.0594 21.2211 12.067 21.5247 12.2188C21.9649 12.439 22.1546 12.7502 22.1546 13.2512C22.1546 13.6991 21.9725 14.0104 21.5778 14.2685C21.3653 14.4051 21.2363 14.4127 19.2174 14.4279C17.9727 14.4355 16.9784 14.4127 16.8267 14.3671C16.0449 14.147 15.7565 13.0235 16.3257 12.4466ZM20.9858 19.6203C16.895 19.6203 16.7508 19.6354 16.4168 19.9315C16.1512 20.1668 15.9842 20.6451 16.0297 20.9867C16.0829 21.3435 16.394 21.7534 16.728 21.8976C16.895 21.9735 17.7981 22.0267 21.001 21.9887L24.6365 21.9432L25.3347 21.8293C26.0178 21.4421 26.1317 20.5084 25.57 19.977C25.1678 19.6203 25.1905 19.6203 20.9858 19.6203ZM37.9413 29.4964C37.6757 31.6523 36.1957 33.3224 34.0629 33.8613C33.5165 33.998 33.3267 34.0056 20.9403 33.998C8.96369 33.998 8.34892 33.9904 7.88594 33.8613C7.24841 33.6943 6.70195 33.4438 6.19343 33.1022C5.76841 32.8138 5.13846 32.2065 4.90318 31.8573C4.61477 31.4322 4.28082 30.6958 4.1442 30.1872C4.00759 29.6786 4 29.4736 4 17.0241C4 4.64281 4 4.37712 4.13662 3.83815C4.61477 1.96312 6.10236 0.528385 8.02256 0.103277C8.57661 -0.0181819 33.2281 -0.0409557 33.8277 0.0805035C35.4367 0.406925 36.7042 1.3786 37.4404 2.8437C38.0248 4.00515 37.9717 2.72983 37.9944 16.5534C38.0096 25.344 37.9944 29.0409 37.9413 29.4964ZM31.4597 15.4375C31.3762 15.0579 31.1409 14.7087 30.8752 14.5645C30.7918 14.519 30.2681 14.4658 29.6988 14.4355C28.7577 14.3899 28.6515 14.3747 28.3479 14.2001C27.8773 13.9269 27.7483 13.6232 27.7407 12.8109C27.7407 11.2623 27.0956 9.82001 25.8205 8.52192C24.9097 7.59579 23.9003 6.96572 22.7391 6.61653C22.4658 6.53302 21.8435 6.50266 19.7639 6.47989C16.5079 6.44193 15.7793 6.51025 14.6712 6.95054C12.6219 7.7628 11.1571 9.486 10.6182 11.6874C10.5196 12.0974 10.4968 12.7654 10.474 16.5686C10.4437 21.3359 10.474 22.0418 10.7776 22.9832C11.5138 25.3137 13.5934 27.0369 15.6806 27.4164C16.3789 27.5455 24.9553 27.5758 25.8281 27.4544C27.3536 27.2494 28.5528 26.6345 29.6761 25.4883C30.4882 24.6608 30.9967 23.7575 31.3306 22.5656C31.5735 21.7382 31.5507 15.855 31.4597 15.4375Z" fill="#DAD7CD"/>
                </g>
                <defs>
                  <filter id="filter0_d_253_9" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_253_9"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_253_9" result="shape"/>
                  </filter>
                </defs>
              </svg>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            name:'',
            email:'',
            project:'',
            message:''
        }
    },
    computed:{
        bg(){
            let theme = this.$store.getters['getTheme']
            if(theme==0){
                return `background:#344E41`
            }
            else if(theme==1){
                return `background:#A3B18A`
            }
            else if(theme==2){
              return 'background:#0C134F'
            }
            else if(theme==3){
              return 'background:#1D267D'
            }
            else{
              return `background:#344E41`
            }
        },
        text(){
            let theme = this.$store.getters['getTheme']
            if(theme==0){
                return `color:#344E41`
            }
            else{
                return `color:`
            }
        },
        theme(){
            return this.$store.getters['getTheme']
        },
    },
    methods:{
        send(){
            //this function will send mail to me
        },
        goto(val){
        window.open(val, '_blank');

      },
      sendMail(){
        window.location.href = `mailto:dumkaabhipray@gmail.com`;
      }
    }
}
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Ingrid+Darling&display=swap');
@media only screen and (max-width:480px){
#sixth-mobile{
        width:100vw;
        height: fit-content;
        overflow-x: hidden;
        overflow-y:auto;
        position: relative;
        margin-left:0 !important;
       z-index: 0;
       padding-top:2vh;
       margin-top:-0.3vh;
       padding-bottom:1vh !important;
    }
    .text-theme-1{
        color: #A3B18A;
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align:center;
    margin-bottom:0px;
    }
    .text-theme-2{
        color: #344E41;
        font-family: Roboto;
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-align: center;
        margin-bottom:0px;
    }
    .text-theme-3{
        color: #5C469C;
        font-family: Roboto;
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-align: center;
        margin-bottom:0px;
    }
    .text-theme-4{
        color: #D4ADFC;
        font-family: Roboto;
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-align: center;
        margin-bottom:0px;
    }
    .h3-theme-1{
        color: #C8CFCC;
        font-family: Roboto;
        font-size: 17px;
        font-style: normal;
        font-weight: 350;
        line-height: normal;
        text-align: center;
        margin-top:2px;
    }
    .h3-theme-2{
        color: #588157;
    font-family: Roboto;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
        margin-top:2px;
        text-align: center;
    }
    #contact{
        width:100vw;
    }
    .contact-info{
        width:100vw;
        display: grid;
        grid-template-columns: 15vw 75vw;
    }
    .contact-icon{
        margin-left:10vw;
        margin-top:3vh;
    }
   
    .contact-detail{
        padding-left:6vw;
    }
    .contact-h2-1{
        color: #DAD7CD;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom:0px;
    }
    .contact-h2-2{
        color: #344E41;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom:0px;
    }
    .contact-h3-1{
        color: #C8CFCC;
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top:3px;
    }
    .contact-h3-2{
        color: #588157;
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top:3px;
    }
    #form{
        width:100vw;
        margin-top:.75vh;
    }
    input,
    input:focus,
    input::selection{
        outline:none;
        border:none;
    }
    .contact-input-1{
        position: relative;
        margin-top:1.5vh;
        margin-bottom:1.5vh;
        width:80vw;
        height:60px;
        border-radius: 5px;
        background: #DAD7CD;
        margin-left:10vw;
        padding-left:2vw;
        color: #344E41;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .contact-input-2{
        position: relative;
        margin-top:1.5vh;
        margin-bottom:1.5vh;
        width:80vw;
        height:60px;
        border-radius: 5px;
        background: #3A5A40;
        margin-left:10vw;
        padding-left:2vw;
        color: #DAD7CD;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .contact-input-3{
        position: relative;
        margin-top:1.5vh;
        margin-bottom:1.5vh;
        width:80vw;
        height:60px;
        border-radius: 5px;
        background: white;
        margin-left:10vw;
        padding-left:2vw;
        color: black;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .contact-input-1::placeholder,
    .contact-text-area-1::placeholder{
        color: #344e41bf;
font-family: Roboto;
font-size: 24px;
font-style: normal;
font-weight: 400;
line-height: normal;
    }
    .contact-input-2::placeholder,
    .contact-text-area-2::placeholder{
        color: #dad7cdb0;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .contact-input-3::placeholder,
    .contact-text-area-3::placeholder{
        color: #090909b0;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    textarea {
        border-style: none;
        border-color: Transparent;
        overflow: auto;
        outline: none;
      }
    .contact-text-area-1{
        margin-left:10vw;
        margin-top:2vw;
        border-radius: 5px;
        padding-left:2vw;
        padding-top:2vw;
background: #DAD7CD;
color: #344E41;
font-family: Roboto;
font-size: 24px;
font-style: normal;
font-weight: 400;
line-height: normal;
    }
    .contact-text-area-2{
        margin-left:10vw;
        margin-top:2vw;
        border-radius: 5px;
        padding-left:2vw;
        padding-top:2vw;
        border-radius: 5px;
background: #3A5A40;
padding-left:2vw;
color: #DAD7CD;
font-family: Roboto;
font-size: 24px;
font-style: normal;
font-weight: 400;
line-height: normal;
    }
    .contact-text-area-3{
        margin-left:10vw;
        margin-top:2vw;
        border-radius: 5px;
        padding-left:2vw;
        padding-top:2vw;
        border-radius: 5px;
background: white;
padding-left:2vw;
color: black;
font-family: Roboto;
font-size: 24px;
font-style: normal;
font-weight: 400;
line-height: normal;
    }
    .pg-2-btn-1{
        width:50vw;
        margin-left:10vw;
        margin-top:2vh;
        height:8vh;
        border-radius: 10px;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        background: #A3B18A;
    }
    .pg-2-btn-1 h3{
        color: #344E41;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 8vh;
    margin-top:0px;
    margin-left:4vw;
    float:left
    }
    .pg-2-btn-1 svg,
    .pg-2-btn-2 svg,
    .pg-2-btn-3 svg,
    .pg-2-btn-4 svg
    {
        float:right;
        margin-right:4vw;
        margin-top:3.2vh;
    }
    .pg-2-btn-2{
        width:50vw;
        margin-left:10vw;
        margin-top:2vh;
        height:8vh;
        border-radius: 10px;
    background: #344E41;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    }
    .pg-2-btn-2 h3{
        color: #A3B18A;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
        font-weight: 600;
        line-height: 8vh;
        margin-top:0px;
        margin-left:4vw;
        float:left
    }
    .pg-2-btn-3{
        width:50vw;
        margin-left:10vw;
        margin-top:2vh;
        height:8vh;
        border-radius: 10px;
        background: #D4ADFC;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    }
    .pg-2-btn-3 h3{
        color: #1D267D;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
        font-weight: 600;
        line-height: 8vh;
        margin-top:0px;
        margin-left:4vw;
        float:left
    }
    .pg-2-btn-4{
        width:50vw;
        margin-left:10vw;
        margin-top:2vh;
        height:8vh;
        border-radius: 10px;
        background: #A2A1B5;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    }
    .pg-2-btn-4 h3{
        color: #1D267D;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
        font-weight: 600;
        line-height: 8vh;
        margin-top:0px;
        margin-left:4vw;
        float:left
    }
    .signature-1{
        color: #A3B18A;
        font-family:Ingrid Darling; ;
        font-size: 48px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left:4vw;
        margin-bottom:0px;
    }
    .signature-2{
        color: #344E41;
font-family:Ingrid Darling;;
font-size: 48px;
font-style: normal;
font-weight: 400;
line-height: normal;
margin-left:4vw;
margin-bottom:0px;
    }
    .signature-3{
        color: #D4ADFC;
font-family:Ingrid Darling;;
font-size: 48px;
font-style: normal;
font-weight: 400;
line-height: normal;
margin-left:4vw;
margin-bottom:0px;
    }
    .sig-1{
        color: #DAD7CD;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top:3px;
        margin-left:4vw;
        margin-bottom:0px;
    }
    .sig-2{
        color: #3A5A40;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top:3px;
        margin-left:4vw;
        margin-bottom:0px;
    }
.a-1{
    color: #DAD7CD;
    font-family: Roboto;
    font-size: 23px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left:2vw;
    margin-right:2vw;
}
.a-2{
    color: #3A5A40;
    font-family: Roboto;
    font-size: 23px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left:2vw;
    margin-right:2vw;
}
.links{
    display: flex;
    flex-direction: row;
    padding-left:10vw;
    margin-top:3px;
}
.links1{
    display: flex;
    flex-direction: row;
    width:100vw;
    justify-content: center;
    margin-top:3px;
}
.links1 svg{
    margin-left:4vw;
    margin-right:4vw;
}
}
@media only screen and (min-width:481px) and (max-width:960px){
  #sixth-mobile{
          width:100vw;
          height: fit-content;
          overflow-x: hidden;
          overflow-y:auto;
          position: relative;
          margin-left:0 !important;
         z-index: 0;
         padding-top:0vh;
         margin-top:-0.3vh;
         padding-bottom:1vh !important;
      }
      .text-theme-1{
          color: #A3B18A;
      font-family: Roboto;
      font-size: 38px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-align:center;
      margin-bottom:0px;
      }
      .text-theme-2{
          color: #344E41;
          font-family: Roboto;
          font-size: 38px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-align: center;
          margin-bottom:0px;
      }
      .text-theme-3{
        color: #5C469C;
        font-family: Roboto;
        font-size: 38px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-align: center;
        margin-bottom:0px;
    }
    
    .text-theme-4{
        color: #D4ADFC;
        font-family: Roboto;
        font-size: 38px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-align: center;
        margin-bottom:0px;
    
    }
      .h3-theme-1{
          color: #C8CFCC;
          font-family: Roboto;
          font-size: 25px;
          font-style: normal;
          font-weight: 350;
          line-height: normal;
          text-align: center;
          margin-top:2px;
      }
      .h3-theme-2{
          color: #588157;
      font-family: Roboto;
      font-size: 25px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
          margin-top:2px;
          text-align: center;
      }
      #contact{
          width:100vw;
      }
      .contact-info{
          width:100vw;
          display: grid;
          grid-template-columns: 15vw 75vw;
      }
      .contact-icon{
          margin-left:10vw;
          margin-top:5vh;
      }
     
      .contact-detail{
          padding-left:2vw;
      }
      .contact-h2-1{
          color: #DAD7CD;
          font-family: Roboto;
          font-size: 38px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin-bottom:0px;
      }
      .contact-h2-2{
          color: #344E41;
          font-family: Roboto;
          font-size: 38px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin-bottom:0px;
      }
      .contact-h3-1{
          color: #C8CFCC;
          font-family: Roboto;
          font-size: 25px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin-top:3px;
      }
      .contact-h3-2{
          color: #588157;
          font-family: Roboto;
          font-size: 25px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin-top:3px;
      }
      #form{
          width:100vw;
          margin-top:.75vh;
      }
      input,
      input:focus,
      input::selection{
          outline:none;
          border:none;
      }
      .contact-input-1{
          position: relative;
          margin-top:1.5vh;
          margin-bottom:1.5vh;
          width:75vw;
          height:60px;
          border-radius: 5px;
          background: #DAD7CD;
          margin-left:10vw;
          padding-left:2vw;
          color: #344E41;
          font-family: Roboto;
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
      }
      .contact-input-2{
          position: relative;
          margin-top:1.5vh;
          margin-bottom:1.5vh;
          width:75vw;
          height:60px;
          border-radius: 5px;
          background: #3A5A40;
          margin-left:10vw;
          padding-left:2vw;
          color: #DAD7CD;
          font-family: Roboto;
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
      }
      .contact-input-3{
        position: relative;
        margin-top:1.5vh;
        margin-bottom:1.5vh;
        width:75vw;
        height:60px;
        border-radius: 5px;
        background: white;
        margin-left:10vw;
        padding-left:2vw;
        color: rgba(0, 0, 0, 0.85);
        font-family: Roboto;
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
      .contact-input-1::placeholder,
      .contact-text-area-1::placeholder{
          color: #344e41bf;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
      }
      .contact-input-2::placeholder,
      .contact-text-area-2::placeholder{
          color: #dad7cdb0;
          font-family: Roboto;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
      }
      .contact-input-3::placeholder,
      .contact-text-area-3::placeholder{
          color: rgba(0,0,0,0.75);
          font-family: Roboto;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
      }
      textarea {
          border-style: none;
          border-color: Transparent;
          overflow: auto;
          outline: none;
        }
      .contact-text-area-1{
          margin-left:10vw;
          width:75vw;
          margin-top:2vw;
          border-radius: 5px;
          padding-left:2vw;
          padding-top:2vw;
  background: #DAD7CD;
  color: #344E41;
  font-family: Roboto;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
      }
      .contact-text-area-2{
          margin-left:10vw;
          margin-top:2vw;
          width:75vw;
          border-radius: 5px;
          padding-left:2vw;
          padding-top:2vw;
          border-radius: 5px;
  background: #3A5A40;
  padding-left:2vw;
  color: #DAD7CD;
  font-family: Roboto;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
      }
      .contact-text-area-3{
        margin-left:10vw;
        margin-top:2vw;
        width:75vw;
        border-radius: 5px;
        padding-left:2vw;
        padding-top:2vw;
        border-radius: 5px;
background: white;
padding-left:2vw;
color: rgba(0,0,0,0.85);
font-family: Roboto;
font-size: 28px;
font-style: normal;
font-weight: 400;
line-height: normal;
    }
      .pg-2-btn-1{
          width:40vw;
          margin-left:30vw;
          margin-top:2vh;
          height:7vh;
          border-radius: 10px;
          box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
          background: #A3B18A;
          display:flex;
          align-items:center;
          justify-content: center;
      }
      .pg-2-btn-1 h3{
          color: #344E41;
      font-family: Inter;
      font-size: 28px;
      font-style: normal;
      font-weight: 600;
      line-height: normal
      }
      .pg-2-btn-1 svg,
      .pg-2-btn-2 svg,
      .pg-2-btn-3 svg,
      .pg-2-btn-4 svg{
          margin-left:1vw;
          margin-top:1vh;
      }
      .pg-2-btn-2{
          width:40vw;
          margin-left:30vw;
          margin-top:2vh;
          height:7vh;
          border-radius: 10px;
      background: #344E41;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      display:flex;
          align-items:center;
          justify-content: center;
      }
      .pg-2-btn-2 h3{
          color: #A3B18A;
      font-family: Inter;
      font-size: 28px;
      font-style: normal;
          font-weight: 600;
          line-height:normal
      }
      .pg-2-btn-3{
        width:40vw;
        margin-left:30vw;
        margin-top:2vh;
        height:7vh;
        border-radius: 10px;
    background: #D4ADFC;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    display:flex;
        align-items:center;
        justify-content: center;
    }
    .pg-2-btn-3 h3{
        color:  #1D267D;
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
        font-weight: 600;
        line-height:normal
    }
    .pg-2-btn-4{
        width:40vw;
        margin-left:30vw;
        margin-top:2vh;
        height:7vh;
        border-radius: 10px;
    background: #A2A1B5;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    display:flex;
        align-items:center;
        justify-content: center;
    }
    .pg-2-btn-4 h3{
        color: #1D267D;
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
        font-weight: 600;
        line-height:normal
    }
      .signature-1{
          color: #A3B18A;
          font-family:Ingrid Darling; ;
          font-size: 48px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          text-align:center;
      }
      .signature-2{
          color: #344E41;
  font-family:Ingrid Darling;;
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
text-align:center;
      }
      .signature-3{
        color: #D4ADFC;
        font-family:Ingrid Darling;;
        font-size: 48px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      text-align:center;
    }
      .sig-1{
          color: #DAD7CD;
          font-family: Roboto;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin-top:-2vh;
          text-align:center;
          margin-bottom:0px;
      }
      .sig-2{
          color: #3A5A40;
          font-family: Roboto;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin-top:-2vh;
          text-align:center;
          margin-bottom:0px;
      }
  .a-1{
      color: #DAD7CD;
      font-family: Roboto;
      font-size: 23px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-left:2vw;
      margin-right:2vw;
  }
  .a-2{
      color: #3A5A40;
      font-family: Roboto;
      font-size: 23px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-left:2vw;
      margin-right:2vw;
  }
  .links{
      display: flex;
      flex-direction: row;
      padding-left:25vw;
      padding-right:25vw;
      margin-top:3px;
  }
  .links1{
      display: flex;
      flex-direction: row;
       padding-left:30vw;
      padding-right:30vw;
      margin-top:3px;
  }
  .links1 svg{
      margin-left:4vw;
      margin-right:4vw;
  }
  }
@media only screen and (min-width:961px){
    #sixth-mobile{
        display: none;
    }
}

</style>